import ProgressBar from './ProgressBar.styled';

export default ProgressBar;
